export function onlyNumbers(value: string) {
  return value.replace(/\D/g, '');
}

export function addPhoneMask(phoneNumber: string) {
  const numbers = onlyNumbers(phoneNumber);
  if (!numbers) return '';

  const chars = numbers.length;
  const ddd = chars > 2 ? `(${numbers.slice(0, 2)}) ` : numbers.slice(0, 2);
  const firstPart = `${numbers.slice(2, 7)}`;
  const lastPart = `-${numbers.slice(7, 11)}`;
  const fullMask = ddd + firstPart + lastPart;

  if (chars <= 7) {
    return ddd + firstPart;
  }

  return fullMask;
}

export function addCepMask(cep: string) {
  const numbers = onlyNumbers(cep);
  if (!numbers) return null;

  if (numbers.length <= 5) return numbers;

  const firstPart = `${numbers.slice(0, 5)}`;
  const lastPart = `-${numbers.slice(5, 8)}`;

  return firstPart + lastPart;
}

export function addCpfOrCnpjMask(value: string) {
  const numbers = onlyNumbers(value);
  const cpnjParts = [];

  if (!numbers) return null;
  if (numbers.length > 14) return null;

  if (numbers.length <= 11) {
    const cpfPartsList = numbers.split(/(\d{3})/g).filter((v) => !!v);
    const cpf = cpfPartsList.join('.');
    return cpf.replace(/\.(?!\d{3})/g, '-');
  }

  cpnjParts.push(`${numbers.slice(0, 2)}`);
  cpnjParts.push(`.${numbers.slice(2, 5)}`);
  cpnjParts.push(`.${numbers.slice(5, 8)}`);
  cpnjParts.push(`/${numbers.slice(8, 12)}`);

  if (numbers.length <= 12) return cpnjParts.join('');

  cpnjParts.push(`-${numbers.slice(12, 14)}`);
  return cpnjParts.join('');
}

export function addDateMask(value: string) {
  const numbers = onlyNumbers(value);

  if (!numbers) return null;

  if (numbers.length <= 2) return numbers;

  const firstPart = `${numbers.slice(0, 2)}`;
  const middlePart = `/${numbers.slice(2, 4)}`;
  const lastPart = `/${numbers.slice(4, 8)}`;

  if (!numbers[4]) return firstPart + middlePart;

  return firstPart + middlePart + lastPart;
}

export function addCreditCardCvvMask(value: string) {
  const numbers = onlyNumbers(value);

  if (!numbers) return null;
  if (numbers.length > 2) return numbers.slice(0, 3);
  return numbers;
}

export function addCreditCardValidateDateMask(value: string) {
  const numbers = onlyNumbers(value);

  if (!numbers) return null;
  if (numbers.length <= 2) return numbers;

  const firstPart = `${numbers.slice(0, 2)}`;
  const lastPart = `/${numbers.slice(2, 4)}`;
  return firstPart + lastPart;
}

export function addCreditCardNumberMask(value: string) {
  const numbers = onlyNumbers(value);

  if (!numbers) return null;

  const creditCardMask = numbers.match(/\d{1,4}/g).join(' ');

  if (numbers.length >= 17) {
    return `${creditCardMask.slice(0, 19)}`;
  }

  return creditCardMask;
}
